import { 
    Home, 
    ListOrdered, 
    History, 
    Utensils, 
    Table, 
    PlusCircle,
    Package
} from "lucide-react";
import Inicio from "./pages/Inicio";
import MeusPedidos from "./pages/MeusPedidos";
import HistoricoPedidos from "./pages/HistoricoPedidos";
import GestaoCardapio from "./pages/GestaoCardapio";
import Mesas from "./pages/Mesas";
import NovoPedido from "./pages/NovoPedido";
import GestaoEstoque from "./pages/GestaoEstoque";
import GestaoInsumos from "./pages/GestaoInsumos";

const routesConfig = [
    { path: "/", element: <Inicio />, icon: <Home size={20} />, text: "Home", protected: true },
    { path: "/pedidos", element: <MeusPedidos />, icon: <ListOrdered size={20} />, text: "Meus Pedidos", protected: true },
    { path: "/historicopedidos", element: <HistoricoPedidos />, icon: <History size={20} />, text: "Histórico Pedidos", protected: true, showList: false },
    { path: "/gestaocardapio", element: <GestaoCardapio />, icon: <Utensils size={20} />, text: "Gestão de Produtos", protected: true },
    { path: "/mesas", element: <Mesas />, icon: <Table size={20} />, text: "Mesas", protected: true },
    { path: "/novopedido", element: <NovoPedido />, icon: <PlusCircle size={20} />, text: "Novo Pedido", protected: true },
    { path: "/gestaoestoque", element: <GestaoEstoque />, icon: <Package size={20} />, text: "Gestão de Estoque", protected: true },
    { path: "/gestaoinsumos", element: <GestaoInsumos />, protected: true, showList: false },
];

export default routesConfig;